import { AppShell } from '@hobbytools/platform';
import { Card } from '@hobbytools/ui';
import type { ReactNode } from 'react';

/** Narrow, single-column layout for sign-in style pages. */
export function AuthLayout({
  title,
  lead,
  children,
  footer,
}: {
  title: string;
  lead?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <AppShell current="hub">
      <div className="mx-auto flex max-w-md flex-col gap-4 py-6">
        <header className="flex flex-col gap-1">
          <h1 className="heading-display text-2xl">{title}</h1>
          {lead ? <p className="text-fg-muted">{lead}</p> : null}
        </header>
        <Card className="flex flex-col gap-4">{children}</Card>
        {footer ? <div className="text-sm text-fg-muted">{footer}</div> : null}
      </div>
    </AppShell>
  );
}

export const linkClass = 'font-medium text-accent-fg underline-offset-4 hover:underline';
